import React, {useEffect, useState} from 'react'
import Header from "../../../layout/header";
import BottomMenu from "../../../layout/bottomMenu";
import "../../../Dashboard/Dashboard.css";
import "../../../Dashboard/Sidebar.js";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure()

const CarServiceAccountView = ({
                      match,
                      history,
                      locationState,
                      accountById,
                      accountByIdDetails = [],
                      locationPinCode,
                      pincodeData=[],
                      oemManufactureName,
                      eomName=[],
                      sitePocTypes,
                      pocTypes=[],
                  }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [pincode, setPincode] = useState([]);
    const [pincodeValue, setPincodeValue] = useState('')

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            if (match?.params?.id !== undefined) {
                await accountById(match?.params?.id)
            }
            await oemManufactureName()
            await sitePocTypes()
            setIsLoading(false)
        })()
    }, [])


    const getCityStateByPincode = async (pincode) => {
        if (pincode === '') {
            return false
        }
        await locationPinCode(pincode)
    }

    useEffect(() => {
        getCityStateByPincode(pincodeValue)
    }, [pincodeValue])

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(true)
            if (pincodeData && pincodeData.length > 0) {
                setPincode(pincodeData[0])
            }
            setIsLoading(false)
        }, 1000)
    }, [pincodeData])

    useEffect(() => {
        if(accountByIdDetails?.data !== undefined){
            setPincodeValue(accountByIdDetails?.data?.pincode)
        }
    }, [accountByIdDetails])

    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Service Center'}
                            history={history}
                        />
                        {/*BODY*/}
                        <div>
                            <div className="container-fluid">
                                <form>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div
                                                className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                <h1 className="h3 mb-0 text-black-100"> Details</h1>
                                            </div>
                                            <div className="card-body bg-white">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        <div
                                                            className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       // handleInput(e.target.value, 'client_name', e)
                                                                   }}
                                                                   required
                                                                   value={accountByIdDetails?.data?.client_name}
                                                                   disabled={true}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Toll Name
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field">
                                                            <select className="form-control"
                                                                    onChange={(e) => {
                                                                        // handleInput(e.target.value, 'oem_manufacturer_name')
                                                                    }} required disabled>
                                                                <option value="">Select OEM Manufacturer Name</option>
                                                                {eomName !== [] &&
                                                                    eomName.map((value, i) => {
                                                                        return (
                                                                            <>
                                                                                {parseInt(value?.id) === parseInt(accountByIdDetails?.data?.oem_manufacturer_name) ?
                                                                                    <option value={`${value?.id}`} selected>{value?.name}
                                                                                    </option>  :
                                                                                    <option value={`${value?.id}`}>{value?.name}
                                                                                    </option>
                                                                                }
                                                                            </>
                                                                        )
                                                                    })}
                                                            </select>
                                                            <label className="large-label float-lb">
                                                                OEM Manufacturer Name
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div
                                                className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                <h1 className="h3 mb-0 text-black-100">Location</h1>
                                            </div>
                                            <div className="card-body bg-white">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        <div
                                                            className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       // handleInput(e.target.value, 'client_name', e)
                                                                   }}
                                                                   required
                                                                   value={accountByIdDetails?.data?.address_1}
                                                                   disabled={true}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Address
                                                            </label>
                                                        </div>
                                                        <div
                                                            className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       // handleInput(e.target.value, 'fast_tag_toll_no', e)
                                                                   }}
                                                                   required
                                                                   value={accountByIdDetails?.data?.longitude}
                                                                   disabled={true}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Longitude
                                                            </label>
                                                        </div>
                                                        <div
                                                            className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       // handleInput(e.target.value, 'fast_tag_toll_no', e)
                                                                   }}
                                                                   required
                                                                   value={accountByIdDetails?.data?.latitude}
                                                                   disabled={true}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Latitude
                                                            </label>
                                                        </div>
                                                        <div
                                                            className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       // handleInput(e.target.value, 'latitude', e)
                                                                   }}
                                                                   required
                                                                   value={accountByIdDetails?.data?.pincode}
                                                                   disabled={true}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Pincode
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       // handleInput(pincode?.geo_city_id, 'geographical_city_id')
                                                                   }}
                                                                   disabled
                                                                   value={pincode?.city_name !== undefined ? pincode?.city_name : ''}
                                                                   required
                                                            />

                                                            <label className="large-label float-lb">
                                                                Geographical City <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       // handleInput(pincode?.geo_state_id, 'geographical_state_id')
                                                                   }}
                                                                   disabled
                                                                   value={pincode?.state_name !== undefined ? pincode?.state_name : ''}
                                                                   required
                                                            />

                                                            <label className="large-label float-lb">
                                                                Geographical State <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div
                                                            className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       // handleInput(e.target.value, 'latitude', e)
                                                                   }}
                                                                   required
                                                                   value={accountByIdDetails?.data?.city_name}
                                                                   disabled={true}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                City
                                                            </label>
                                                        </div>
                                                        <div
                                                            className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       // handleInput(e.target.value, 'latitude', e)
                                                                   }}
                                                                   required
                                                                   value={accountByIdDetails?.data?.zone_name}
                                                                   disabled={true}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Zone
                                                            </label>
                                                        </div>
                                                        <div
                                                            className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       // handleInput(e.target.value, 'latitude', e)
                                                                   }}
                                                                   required
                                                                   value={accountByIdDetails?.data?.area_name}
                                                                   disabled={true}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Area
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div
                                                className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                <h1 className="h3 mb-0 text-black-100">Poc Details</h1>
                                            </div>
                                            <div className="card-body bg-white">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        {accountByIdDetails?.data?.poc_details !== undefined && accountByIdDetails?.data?.poc_details !== null
                                                        && accountByIdDetails?.data?.poc_details.map((val, i) => {
                                                            return (
                                                                <>
                                                                    <div
                                                                        className="col-sm-6 col-md-3 mt-1 float-field">
                                                                        <input type="text"
                                                                               className="form-control form-control-user"
                                                                               placeholder=" "
                                                                               onChange={(e) => {
                                                                                   // handleInput(e.target.value, 'client_name', e)
                                                                               }}
                                                                               required
                                                                               value={val?.name}
                                                                               disabled={true}
                                                                        />
                                                                        <label
                                                                            className="large-label float-lb">
                                                                            Name
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-md-6 float-field mt-sel">
                                                                        <select className="form-control"
                                                                                onChange={(e) => {
                                                                                }} disabled>
                                                                            <option value="">Select Designation Name
                                                                            </option>
                                                                            {pocTypes !== [] &&
                                                                                pocTypes.map((value, i) => {
                                                                                    return (
                                                                                        <>
                                                                                            {parseInt(value?.id) === parseInt(val?.designation_type_id) ?
                                                                                                <option value={`${value?.id}`} selected>{value?.name}
                                                                                                </option>  :
                                                                                                <option value={`${value?.id}`}>{value?.name}
                                                                                                </option>
                                                                                            }
                                                                                        </>
                                                                                    )
                                                                                })}
                                                                        </select>
                                                                    </div>
                                                                    {val?.Designation_Other !== "" && val?.Designation_Other !== null &&
                                                                        <div
                                                                            className="col-sm-6 col-md-3 mt-1 float-field">
                                                                            <input type="text"
                                                                                   className="form-control form-control-user"
                                                                                   placeholder=" "
                                                                                   onChange={(e) => {
                                                                                       // handleInput(e.target.value, 'client_name', e)
                                                                                   }}
                                                                                   required
                                                                                   value={val?.Designation_Other}
                                                                                   disabled={true}
                                                                            />
                                                                            <label
                                                                                className="large-label float-lb">
                                                                                Designation Other
                                                                            </label>
                                                                        </div>
                                                                    }
                                                                    <div
                                                                        className="col-sm-6 col-md-3 mt-1 float-field">
                                                                        <input type="text"
                                                                               className="form-control form-control-user"
                                                                               placeholder=" "
                                                                               onChange={(e) => {
                                                                                   // handleInput(e.target.value, 'client_name', e)
                                                                               }}
                                                                               required
                                                                               value={val?.company_name}
                                                                               disabled={true}
                                                                        />
                                                                        <label
                                                                            className="large-label float-lb">
                                                                            Company Name
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        className="col-sm-6 col-md-3 mt-1 float-field">
                                                                        <input type="text"
                                                                               className="form-control form-control-user"
                                                                               placeholder=" "
                                                                               onChange={(e) => {
                                                                                   // handleInput(e.target.value, 'client_name', e)
                                                                               }}
                                                                               required
                                                                               value={val?.email}
                                                                               disabled={true}
                                                                        />
                                                                        <label
                                                                            className="large-label float-lb">
                                                                            Email
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        className="col-sm-6 col-md-3 mt-1 float-field">
                                                                        <input type="text"
                                                                               className="form-control form-control-user"
                                                                               placeholder=" "
                                                                               onChange={(e) => {
                                                                                   // handleInput(e.target.value, 'client_name', e)
                                                                               }}
                                                                               required
                                                                               value={val?.number}
                                                                               disabled={true}
                                                                        />
                                                                        <label
                                                                            className="large-label float-lb">
                                                                            Contact Number
                                                                        </label>
                                                                    </div>

                                                                    <hr/>
                                                                </>
                                                            )
                                                         })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex">
                                        <a href={`car-service-account-update/${match?.params?.id}`}
                                           className="draft-float">
                                            <p className="my-float">Edit</p>
                                        </a>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default CarServiceAccountView